import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const duetteConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Duette Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Duette, FL. Sam\'s Tree Service handles large rural and dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_duette',

/* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Duette',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Duette Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we travel to the rural stretches of 
     <strong>Duette</strong> to handle the kind of tree work that larger, less flexible 
     companies skip over. Remote properties, large acreage lots, and the heavy tree growth 
     common to this part of Manatee County all create real hazards when storm season 
     arrives. Fallen trees blocking roads, split trunks near homes, and massive overhanging 
     limbs our team handles all of it.`,

    `We specialize in <strong>heavy duty rural tree removal and clearing</strong>
     including large tree takedowns, post storm debris removal, hazardous limb clearing 
     from driveways and structures, and canopy trimming on trees that have grown well 
     beyond what's safe. We bring the right equipment for the job regardless of how remote 
     the property is.`,

    `<strong>Sam's Tree Service</strong> provides reliable, expert tree care throughout 
     <strong>Duette</strong> and the surrounding <strong>Rural Manatee County</strong> 
     area giving property owners the professional service they deserve no matter how 
     far off the beaten path they are.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Duette, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Duette = () => <LocationPage config={duetteConfig} />;
export default Services_Duette;
